import { createReducer } from '@reduxjs/toolkit';
import {
  updateActiveProfileForm,
  updateLatestSubmissionOutcome,
  updateProfileStatus,
  updateSubmittingForm,
  userRequestedProfileUpdate,
} from './profile.actions';
import { ProfileForms } from './profile.config';
import { SubmissionOutcome } from './profile.types';

const initialState = {
  status: {} as Record<string, any>,
  activeForm: null as ProfileForms | null,
  submittingForm: null as ProfileForms | null,
  latestSubmissionOutcome: {
    profileForm: null,
    errors: null,
  } as SubmissionOutcome,
};

const profileReducer = createReducer(initialState, (builder) =>
  builder
    .addCase(updateProfileStatus, (state, action) => {
      Object.assign(state.status, action.payload);
    })
    .addCase(updateActiveProfileForm, (state, action) => {
      if (state.submittingForm === null || action.payload === null) {
        state.latestSubmissionOutcome = initialState.latestSubmissionOutcome;
        state.activeForm = action.payload;
      }
    })
    .addCase(updateSubmittingForm, (state, action) => {
      state.submittingForm = action.payload;
    })
    .addCase(userRequestedProfileUpdate, (state, { payload }) => {
      // Closes all forms.
      state.activeForm = null;
      state.submittingForm = payload.profileFormType;
    })
    .addCase(updateLatestSubmissionOutcome, (state, action) => {
      state.latestSubmissionOutcome = action.payload;
    }),
);

export default profileReducer;
